var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 7V15.75H16.5V7H3.5ZM3 5.25C2.30964 5.25 1.75 5.80964 1.75 6.5V16.25C1.75 16.9404 2.30964 17.5 3 17.5H17C17.6904 17.5 18.25 16.9404 18.25 16.25V6.5C18.25 5.80964 17.6904 5.25 17 5.25H3Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40463 4.25L7.18241 5.25H12.7393L12.48 4.25H7.40463ZM7.00355 2.5C6.41767 2.5 5.91041 2.90692 5.78331 3.47884L5.33887 5.47884C5.16539 6.25948 5.75942 7 6.5591 7H13.3854C14.2031 7 14.8006 6.22783 14.5954 5.4363L14.0769 3.4363C13.934 2.88499 13.4364 2.5 12.8669 2.5H7.00355Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 9.25C12.375 8.76675 12.7668 8.375 13.25 8.375L14.25 8.375C14.7332 8.375 15.125 8.76675 15.125 9.25C15.125 9.73325 14.7332 10.125 14.25 10.125L13.25 10.125C12.7668 10.125 12.375 9.73325 12.375 9.25Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 12.75C9.07843 12.75 9.75 12.0784 9.75 11.25C9.75 10.4216 9.07843 9.75 8.25 9.75C7.42157 9.75 6.75 10.4216 6.75 11.25C6.75 12.0784 7.42157 12.75 8.25 12.75ZM8.25 14.5C10.0449 14.5 11.5 13.0449 11.5 11.25C11.5 9.45507 10.0449 8 8.25 8C6.45507 8 5 9.45507 5 11.25C5 13.0449 6.45507 14.5 8.25 14.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.de9f9d4ef8817a731cd393017b0a3f52.svg";
export { ForwardRef as ReactComponent };